'use client';

import { BottomBar } from '@org/ui';
import { useLanguage } from '@/lib/config/useLanguage';
import useCart from '@/hooks/useCart';

export default function BottomBarComponent() {
    const { getNavigation, t, localizePath } = useLanguage();
    const { totalQuantity } = useCart();
    
    // Получаем элементы навигации для bottomBar
    const navigationItems = getNavigation('bottomBar') || [];
    
    // Функция для получения переводов
    const getTranslation = (key, fallback) => {
        // Пробуем получить перевод из common секции
        const translation = t(key, 'common');
        // Если перевод не найден, возвращаем fallback или сам ключ
        return translation !== key ? translation : (fallback || key);
    };
    
    // Функция для получения значения бейджа
    const getBadgeValue = (key) => {
        if (key === 'cart') {
            return totalQuantity > 0 ? totalQuantity : null;
        }
        return null;
    };
    
    if (navigationItems.length === 0) {
        return null;
    }
    
    return (
        <BottomBar
            items={navigationItems.map(item => ({
                label: getTranslation(item.name, item.name),
                href: localizePath(item.url || '/'),
                icon: item.icon,
                iconType: item.iconType,
                badgeKey: item.badgeKey,
            }))}
            getTranslation={getTranslation}
            getBadgeValue={getBadgeValue}
        />
    );
}
